import { FirstPlaceAwardIcon } from './FirstPlaceAwardIcon';
import { SecondPlaceAwardIcon } from './SecondPlaceAwardIcon';
import { ThirdPlaceAwardIcon } from './ThirdPlaceAwardIcon';

export const AwardPlaces = {
  First: FirstPlaceAwardIcon,
  Second: SecondPlaceAwardIcon,
  Third: ThirdPlaceAwardIcon,
};

export const AwardIcon = ({ place }: { place: number }) => {
  switch (place) {
    case 1:
      return <AwardPlaces.First />;
    case 2:
      return <AwardPlaces.Second />;
    case 3:
      return <AwardPlaces.Third />;
    default:
      return null;
  }
};
